module.exports = __webpack_public_path__ + "img/none.77a1a9c3.png";